<obg-m-dropdown-menu width="400px" autoClose>
	<!-- todo: icon - place icon here and provide spacing -->
	<button
		test-id="oms-summary-toggle-button"
		[obgInteraction]="omsTrackingData"
		mat-mini-fab
		trigger
		matTooltip="{{'general.notifications' | translate}}"
		matTooltipClass="obg-m-navigation-tooltip"
		(click)="clickStream$.next($event)"
	>
		<span
			class="ico-mail"
			[matBadge]="unreadMessagesCount$ | async"
			matBadgeColor="accent"
			matBadgePosition="above after"
			[matBadgeHidden]="!(unreadMessagesCount$ | async)"
		></span>
	</button>
	<obg-app-m-oms-summary-list
		menu
		[messages]="messages$ | async"
		[showMoreCount]="showMoreCount"
		(show)="goToOmsCenter($event)"
		[busy]="isBusy$ | async"
	>
	</obg-app-m-oms-summary-list>
</obg-m-dropdown-menu>
